<template>
  <div></div>
</template>
<script type="text/babel">
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
  created() {
    this.$router.push('/auth/login')
  },
}
</script>

<style lang="scss" scoped></style>
